import { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

import '../styles/ProjectNewJeans.css'; 

gsap.registerPlugin(ScrollTrigger);

export default function ProjectNewJeans() {
    const mainContainerRef = useRef(null);
    const cursorRef = useRef(null);

    useEffect(() => {
        // 1. On utilise gsap.context() pour isoler les animations de ce composant
        let ctx = gsap.context(() => {
            
            // --- PARALLAXE ---
            const parallaxElements = gsap.utils.toArray(".sticker");
            
            parallaxElements.forEach(layer => {
                const speed = layer.dataset.speed;
                gsap.to(layer, {
                    y: () => -400 * speed,
                    ease: "none",
                    scrollTrigger: {
                        trigger: mainContainerRef.current, // On utilise la Ref du conteneur parent
                        start: "top top",
                        end: "bottom bottom",
                        scrub: 1
                    }
                });
            });

            // --- CURSEUR (Initialisation) ---
            gsap.set(cursorRef.current, {xPercent: -50, yPercent: -50});
            
        }, mainContainerRef); // Le scope de la recherche GSAP se limite à ce conteneur

        // --- GESTION DES ÉVÉNEMENTS SOURIS ---
        const handleMouseMove = (e) => {
            gsap.to(cursorRef.current, {
                x: e.clientX,
                y: e.clientY,
                duration: 0.15,
                ease: "power2.out"
            });
        };

        const handleMouseDown = () => gsap.to(cursorRef.current, { scale: 0.7, duration: 0.1 });
        const handleMouseUp = () => gsap.to(cursorRef.current, { scale: 1, duration: 0.1 });

        // Ajout des écouteurs globaux
        window.addEventListener('mousemove', handleMouseMove);
        window.addEventListener('mousedown', handleMouseDown);
        window.addEventListener('mouseup', handleMouseUp);

        // --- NETTOYAGE ---
        return () => {
            ctx.revert(); // Nettoie toutes les animations GSAP et ScrollTriggers de ce composant
            window.removeEventListener('mousemove', handleMouseMove);
            window.removeEventListener('mousedown', handleMouseDown);
            window.removeEventListener('mouseup', handleMouseUp);
        };
    }, []);

    return (
        <div className="newjeans-page" ref={mainContainerRef}>
            <div className="cursor-newjeans" ref={cursorRef}></div>

            <div className="container-newjeans">
                <h1 className="title-nj">
                    <span className="highlight">Newjeans</span> Never Die
                </h1>

                <img 
                    src="https://payload.cargocollective.com/1/16/528101/14404891/2k_670.png" 
                    className="sticker sticker-1" 
                    data-speed="0.3" 
                    alt="star sticker" 
                />

                <div className="gallery-section">
                    <div className="polaroid">
                        <div className="tape tape-pink"></div>
                        <img src="https://legacy.kpopping.com/e7/1/NewJeans-Ditto-Concept-Teasers-documents-8.jpeg" alt="Ditto Concept" />
                        <div class="handwritten-note">Ditto vibe ~</div>
                    </div>

                    <div className="polaroid">
                        <div className="tape tape-blue"></div>
                        <img src="https://static.wikia.nocookie.net/witchers/images/4/47/NewJeans_Super_Shy_Concept_Photo_%281%29.jpg/revision/latest/scale-to-width-down/1000?cb=20230707141914" alt="Super Shy Concept" />
                        <div className="handwritten-note">Super Shy 🐰✨</div>
                    </div>

                    <div className="polaroid">
                        <div className="tape tape-purple"></div>
                        <img src="https://static.wikia.nocookie.net/witchers/images/f/fc/NewJeans_OMG_Concept_Photo_%284%29.jpg/revision/latest/scale-to-width-down/1000?cb=20230102103632" alt="OMG Concept" />
                        <div className="handwritten-note">OMG ! 💙</div>
                    </div>
                </div>

                <img 
                    src="https://media.tenor.com/IDnTxCR3258AAAAj/newjeansbunnyhop.gif" 
                    className="sticker sticker-2" 
                    data-speed="1.2" 
                    alt="bunny sticker" 
                />

                <p style={{ marginTop: '150px', textAlign: 'center', fontFamily: "'Indie Flower', cursive", fontSize: '3rem' }}>
                    🚧 En construction 🚧
                </p>
            </div>
        </div>
    );
}